import { AbacusClient } from "@abacus/api-client";

import {
  AbacusRoyaltiesClientOptions,
  HelloResponse,
  StatementPeriodAdjustmentFile,
  StatementPeriodPaymentEntityState,
} from "./types";

export class AbacusRoyaltiesClient {
  static readonly Domain = "ows-royalties.theorchard.io";

  client: AbacusClient;

  constructor(opts: AbacusRoyaltiesClientOptions) {
    this.client =
      opts.client ??
      new AbacusClient({
        domain: opts.domain ?? AbacusRoyaltiesClient.Domain,
        env: opts.env,
        identityId: opts.identityId,
        logger: opts.logger,
        throttler: opts.throttler,
      });
  }

  /**
   * Get statement period adjustment file by ID.
   *
   * @param adjustmentFileId - ID of the statement period adjustment file
   * @return - OWS Response
   */
  getStatementPeriodAdjustmentFile(
    adjustmentFileId: number,
  ): Promise<StatementPeriodAdjustmentFile> {
    return this.client.get(
      `statement-period-adjustment-file/${adjustmentFileId}`,
    );
  }

  /**
   * Get statement_period_payment_entity states for the statement_period.
   * @param statementPeriodId ID of the statement_period to apply adjustments
   * @returns OWS Response
   */
  getStatementPeriodPaymentEntityStates(
    statementPeriodId: number,
  ): Promise<StatementPeriodPaymentEntityState[]> {
    return this.client.get(
      `/statement-period/${statementPeriodId}/payment-entities/states`,
    );
  }

  hello(): Promise<HelloResponse> {
    return this.client.get(`hello`);
  }

  /**
   * Get statement_period_payment_entity states for the statement_period.
   * @param statementPeriodId ID of the statement_period to apply adjustments
   * @returns OWS Response
   */
  updateStatementPeriodAdjustmentFile(
    statementPeriodId: number,
    adjustmentFileId: number,
    data: unknown,
  ): Promise<StatementPeriodAdjustmentFile> {
    return this.client.put(
      `/statement-period/${statementPeriodId}/adjustment-file/${adjustmentFileId}`,
      data,
    );
  }
}
